var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 526,
    viewBox: "0 0 520 526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 75.9604C0.5 32.8377 36.7771 -1.40306 79.828 1.08544L260 11.5L440.172 1.08544C483.223 -1.40306 519.5 32.8377 519.5 75.9604V231.25V417.886C519.5 454.364 493.255 485.551 457.315 491.784L270.67 524.15C263.593 525.377 256.377 525.581 249.242 524.756L66.8868 503.675C29.0498 499.301 0.5 467.26 0.5 429.171V231.25V75.9604Z",
    fill: "#FCEDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.a4051f8c4bbbd52a2f2eaea245e6a64b.svg";
export { ForwardRef as ReactComponent };